import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, ActivationStart, Router } from '@angular/router';
import { Practice } from '@models/practice.model';
import { AlertService } from '@services/alert.service';
import { DisplayService } from '@services/display.service';
import { PracticeService } from '@services/practice.service';

import { Subject } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'gc-doctor',
  templateUrl: './doctor.component.html',
  styleUrls: ['./doctor.component.scss'],
})
export class DoctorComponent implements OnDestroy {
  unsubscribe$ = new Subject<void>();
  identifier: string;
  practice: Practice;

  constructor(
    private readonly display: DisplayService,
    private readonly route: ActivatedRoute,
    private readonly alert: AlertService,
    private readonly router: Router,
    private readonly practiceService: PracticeService,
  ) {
    this.route.params
      .pipe(
        filter((params) => !!params.identifier),
        switchMap((params) => this.practiceService.getPractice$(params.identifier)),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(
        (p) => {
          this.practice = p;
          if (p.theme.primary && p.theme.accent) {
            this.display.changeTheme(p.theme.primary, p.theme.accent);
          }
        },
        () => {
          this.alert.snackbar('This is not a valid URL.');
        },
      );
    this.router.events.subscribe((event) => {
      if (event instanceof ActivationStart) {
        this.display.resetTheme();
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
  }
}
